import './FormInfo.scss'
import React from 'react'

interface Props {
	label: string
	value?: string | undefined
	children?: React.ReactNode
	disabled?: boolean
}

export function FormInfo({ label, value, children, disabled }: Props) {
	return (
		<div className="form-info ">
			{value ? (
				<FormInfoValue disabled={disabled}>{value}</FormInfoValue>
			) : null}
			{children}
			<span className="label">{label}</span>
		</div>
	)
}

function FormInfoValue({ children, disabled = false }: any) {
	return (
		<div className={`value ${disabled ? 'disabled' : ''}`}>{children}</div>
	)
}

function FormInfoFloatRight({ children }: any) {
	return <div className="float-right">{children}</div>
}

FormInfo.FloatRight = FormInfoFloatRight
FormInfo.Value = FormInfoValue
